/**
 * One short list under a sub-head a level quieter than the section's own — the
 * shape both list-shaped readings take: conversation notes' three buckets, and
 * the relationship read's two.
 *
 * It lived inside `fit.tsx` as `TalkList` until the second reading needed it.
 * The rule it carries is the reason it is one component rather than two copies:
 * **an empty list prints nothing rather than an empty head.** "Carry lightly"
 * over nothing reads as a warning withheld, and "Connections" over nothing reads
 * as a search that came back empty when in fact none was made.
 */
export function LabelledList({ label, lines }: { label: string; lines: string[] }) {
  if (lines.length === 0) return null;
  return (
    <div className="talk-list">
      <div className="sc talk-head">{label}</div>
      <ul>
        {/* Index-composed: the model writes these lines, and two identical
            openers in one list is a duplicate React key, not an impossibility. */}
        {lines.map((line, index) => (
          <li key={`${index}-${line}`}>{line}</li>
        ))}
      </ul>
    </div>
  );
}
